import { config } from '@tamagui/config';
import { createTamagui, createTokens } from 'tamagui';

/**
 * --- Design Tokens ---
 */
const tokens = createTokens({
  color: {
    brand: '#FF4815',
    brand90: 'rgba(255, 72, 21, 0.9)',
    brand80: 'rgba(255, 72, 21, 0.8)',
    brand70: 'rgba(255, 72, 21, 0.7)',
    secondary: '#27282A',
    secondary75: 'rgba(39, 40, 42, 0.75)',
    secondary50: 'rgba(39, 40, 42, 0.5)',
    secondary25: 'rgba(39, 40, 42, 0.25)',
    tertiary: '#E7E5DA',
    tertiary75: 'rgba(231, 229, 218, 0.75)',
    tertiary50: 'rgba(231, 229, 218, 0.5)',
    tertiary25: 'rgba(231, 229, 218, 0.25)',
    errorFont: '#B4142F',
    errorBg: '#FEE5D6',
    error: '#F93B34',
    warningFont: '#FF4815',
    warningBg: '#FFE8D0',
    infoFont: '#0E1D7A',
    infoBg: '#DBE7FF',
    info: '#4C76FF',
    successFont: '#116610',
    successBg: '#EFFCDE',
    success: '#7BD657',
    shadow: 'rgba(0, 0, 0, 0.1)',
  },
  space: {
    0: 0,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 24,
    6: 32,
    7: 48,
    true: 16,
  },
  radius: {
    0: 0,
    1: 4,
    2: 8,
    3: 16,
    4: 24,
    true: 0,
    modal: 24,
    circle: 1000,
  },
  size: {
    0: 0,
    1: 24,
    2: 32,
    3: 40,
    4: 48,
    5: 56,
    true: 40,
    separator: 1,
    compactPageWidth: 520,
  },
  zIndex: {
    0: 0,
    1: 100,
    2: 200,
    3: 300,
    4: 400,
    5: 500,
    true: 0,
  },
});

/**
 * --- Font Families ---
 */
const fonts = {
  heading: {
    family: 'SohneSchmalRegular',
    size: {
      10: 48,
      9: 40,
      8: 33,
      7: 28,
      6: 23,
      5: 19,
      true: 33,
    },
    weight: {
      sm: 400,
      md: 600,
      lg: 800,
      true: 400,
    },
  },
  body: {
    family: 'SohneRegular',
    size: {
      1: 16,
      2: 13,
      3: 11,
      true: 16,
    },
  },
  bold: {
    family: 'SohneMedium',
    size: {
      1: 16,
      2: 13,
      3: 11,
      h6: 19,
      true: 16,
    },
  },
};

/**
 * --- Themes ---
 */
const lightTheme = {
  background: '#FFFFFF',
  backgroundHover: tokens.color.tertiary,
  backgroundPress: tokens.color.tertiary75,
  color: tokens.color.secondary,
  colorMuted: tokens.color.secondary75,
  borderColor: tokens.color.secondary25,
  borderColorHover: tokens.color.secondary50,
  borderColorPress: tokens.color.secondary75,
};

export const appConfig = createTamagui({
  ...config,
  tokens,
  fonts,
  themes: {
    light: lightTheme,
  },
});

export type AppConfig = typeof config;

declare module 'tamagui' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface TamaguiCustomConfig extends AppConfig {}
}
